import { GetStaticProps } from "next";
import { CameraData } from "@web/types/CameraData";
import { getCameraData } from "@web/utils/camera/getCameraData";
import { ComparePage } from "@web/pages/compare/ComparePage";

export const getStaticProps: GetStaticProps = async () => {
  const csvData = await getCameraData();
  // Filter out rows that are not verified
  return {
    props: {
      csvData: csvData.filter((row) => row.Verified),
    },
  };
};

type Props = {
  csvData: Array<CameraData>;
};

export default function Compare({ csvData }: Props) {
  return <ComparePage cameraDataArray={csvData} />;
}
